import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Box } from '@mui/material';
import type { FC } from 'react';

const OrderDocumentIcon: FC = () => (
  <Box textAlign={'center'} position={'relative'}>
    <InsertDriveFileOutlinedIcon sx={{ fontSize: 56, color: 'text.secondary' }} />
  </Box>
);

export default OrderDocumentIcon;
